module.exports = __webpack_public_path__ + "static/ux_thumbnail-m-60bd12b869f1c4db98f19a734a918e3e.png";